import { useEffect, useState } from 'react';
import { fetchPlanPrice, isRealBilling } from './billing';
import { DABBEH_PRICE_TOMAN } from './constants';

/**
 * The price every screen shows: Plus's own plan price (what checkout charges), our constant until Plus
 * answers or when it cannot. `active` = false skips asking (e.g. a closed sheet).
 */
export const usePlanPrice = (active = true) => {
  const [price, setPrice] = useState(DABBEH_PRICE_TOMAN);
  useEffect(() => {
    if (!active || !isRealBilling()) return;
    let cancelled = false;
    fetchPlanPrice().then(value => !cancelled && setPrice(value));
    return () => {
      cancelled = true;
    };
  }, [active]);
  return price;
};
